import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Images } from "../../../assets/images";
import { Helmet } from "react-helmet";
import { PageLoader } from "../NewLandingPage/components/PageLoader";

export default function WebinarPage() {
  const [playingVideo, setPlayingVideo] = useState(null);

  const handleVideoPlay = (videoId) => {
    setPlayingVideo(playingVideo === videoId ? null : videoId);
  };

  useEffect(() => {
    const id = window.location.hash.replace("#", "");

    if (id === "webinar#two") {
      const element = document.getElementById("webinar#two");

      if (element) {
        setTimeout(() => {
          const yOffset = -120;
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 700); // wait for full render
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, []);

  const [criticalImagesLoaded, setCriticalImagesLoaded] = useState(false);

  useEffect(() => {
    const criticalImages = [Images.Webinar].filter(Boolean);

    if (criticalImages.length === 0) {
      setCriticalImagesLoaded(true);
      return;
    }

    let loadedCount = 0;
    const totalImages = criticalImages.length;

    const handleLoad = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        setTimeout(() => setCriticalImagesLoaded(true), 300);
      }
    };

    criticalImages.forEach((src) => {
      const img = new Image();
      img.onload = img.onerror = handleLoad;
      img.src = src;
    });

    const timeout = setTimeout(() => setCriticalImagesLoaded(true), 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Online Dispute Resolution (ODR) Webinar Videos - IAMC</title>
        <meta
          name="description"
          content="IAMC conducts several webinar sessions on ODR with experts who will debate different issues and aspects of mediation, arbitration and other dispute resolution processes."
        />
        <meta
          name="keywords"
          content="Online Dispute Resolution Webinar, Arbitration and Mediation Webinar, Online Dispute Webinar, Arbitration Mediation and Conciliation, Resolve Disputes online, Alternative Dispute Resolution Online, IAMC"
        />
      </Helmet>

      <PageLoader isLoading={!criticalImagesLoaded} />

      <PageWrapper>
        <Hero bgImage={Images.Webinar}>
          <h1>Webinars</h1>
        </Hero>
        <WebinarSection>
          <WebinarCard id="webinar#one">
            {/* Webinar 1 */}
            <VideoSection>
              <VideoCard>
                <VideoThumbnail onClick={() => handleVideoPlay("46bbKLdd4Z8")}>
                  {playingVideo === "46bbKLdd4Z8" ? (
                    <YouTubeIframe
                      src="https://www.youtube.com/embed/46bbKLdd4Z8?autoplay=1&rel=0&modestbranding=1"
                      title="Opportunities & Challenges in Online Dispute Resolution"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <>
                      <VideoOverlay showOverlay={true}>
                        <PlayButton />
                      </VideoOverlay>
                      <ThumbnailImg
                        src={require("../../../assets/images/webiniar.png")}
                        alt="Webinar: Opportunities & Challenges in ODR"
                      />
                    </>
                  )}
                </VideoThumbnail>
              </VideoCard>
            </VideoSection>

            <WebinarContent>
              <h3>
                Online Dispute Resolution Webinar - Opportunities & Challenges
              </h3>
              <p>
                Over the next few months, we will have several sessions with
                experts who will debate different issues and aspects of
                mediation, arbitration and other dispute resolution processes.
                The first of the series was on the Opportunities and Challenges
                in Online Dispute Resolution - do the opportunities outweigh
                denial of access to underserved communities? Our expert
                panelists are Siddharth D'Souza and Harish Narasappa.Mr. Karthik
                Krishna , founder of IAMC, stood as the moderator for this
                event
              </p>
            </WebinarContent>
          </WebinarCard>

          {/* Webinar 2 */}
          <WebinarCard id="webinar#two">
            <VideoSection>
              <VideoCard>
                <VideoThumbnail onClick={() => handleVideoPlay("RbPb68VO3pE")}>
                  {playingVideo === "RbPb68VO3pE" ? (
                    <YouTubeIframe
                      src="https://www.youtube.com/embed/RbPb68VO3pE?autoplay=1&rel=0&modestbranding=1"
                      title="Evaluation of Section 11 & 29A in Arbitration"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <>
                      <VideoOverlay showOverlay={true}>
                        <PlayButton />
                      </VideoOverlay>
                      <ThumbnailImg
                        src={require("../../../assets/images/webiniar.png")}
                        alt="Webinar: Evaluation of Section 11 & Section 29A"
                      />
                    </>
                  )}
                </VideoThumbnail>
              </VideoCard>
            </VideoSection>

            <WebinarContent>
              <h3>
                Online Dispute Resolution Webinar - Evaluation of Section 11 &
                Section 29A
              </h3>
              <p>
                Our latest webinar in the series evaluated Section 11 & 29A;
                analyzing their impact in expediting or impeding the arbitral
                process. Our expert panelists were Mr. Murari Raghavan and Mr.
                Vyapak Desai. Mr. Amit George , Advocate at the High Court of
                Delhi stood as moderator of this event.
              </p>
            </WebinarContent>
          </WebinarCard>
        </WebinarSection>
      </PageWrapper>
    </>
  );
}

// Styled Components - Fully Responsive & Mobile-First

const PageWrapper = styled.div`
  font-family: "Arial", sans-serif;
  color: #333;
  width: 100%;
  overflow-x: hidden;
`;

export const Hero = styled.section`
  position: relative;
  width: 100%;
  height: 220px;
  background: url(${(props) => props.bgImage}) center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    color: #fff;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    padding: 0 20px;
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.7);
    z-index: 2;
  }

  @media (min-width: 480px) {
    height: 260px;
    h1 {
      font-size: 32px;
    }
  }

  @media (min-width: 768px) {
    height: 320px;
    h1 {
      font-size: 40px;
    }
  }

  @media (min-width: 1024px) {
    height: 380px;
    h1 {
      font-size: 48px;
    }
  }
`;

const WebinarSection = styled.section`
  padding: 40px 5%;

  @media (min-width: 768px) {
    padding: 60px 8%;
  }

  @media (min-width: 1200px) {
    padding: 80px 10%;
  }
`;

const WebinarCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 60px;
  gap: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 40px;

    &:nth-child(even) {
      flex-direction: row-reverse;
    }
  }

  @media (min-width: 1024px) {
    gap: 60px;
  }
`;

const WebinarContent = styled.div`
  flex: 1;
  text-align: center;

  h3 {
    color: #00838c;
    font-size: 20px;
    margin-bottom: 16px;
    font-family: "openSans-SemiBold", Arial, sans-serif;
    line-height: 1.4;
  }

  p {
    font-size: 15px;
    line-height: 1.7;
    color: #293461;
    font-family: "openSans-SemiBold", Arial, sans-serif;
  }

  @media (min-width: 768px) {
    text-align: left;

    &:nth-child(even) ${WebinarCard} & {
      text-align: left;
    }

    h3 {
      font-size: 24px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const ThumbnailImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const VideoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 2.5rem;
  }

  @media (min-width: 1024px) {
    gap: 3rem;
  }
`;

const VideoCard = styled.div`
  background: #f8f9fa;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const VideoThumbnail = styled.div`
  aspect-ratio: 16 / 9;
  position: relative;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
`;

const YouTubeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
`;

const PlayButton = styled.div`
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 2;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

  &:hover,
  &:active {
    background: white;
    transform: scale(1.15);
  }

  &::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 20px solid #00818a;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    margin-left: 4px;
  }

  @media (min-width: 768px) {
    width: 80px;
    height: 80px;

    &::after {
      border-left: 25px solid #00818a;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
    }
  }
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.showOverlay ? 1 : 0)};
  transition: opacity 0.4s ease;
  z-index: 1;
`;
